import {
    SET_PASSWORD,
    SET_PASSWORD_SUCCESSFUL,
    SET_PASSWORD_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    setPasswordError: null,
    message: null,
    loading: false,
    user: null,
  }
  
  const pwdSet = (state = initialState, action) => {
    switch (action.type) {
      case SET_PASSWORD:
        state = {
          ...state,
          loading: true,
          setPasswordError: null,
        }
        break
      case SET_PASSWORD_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          user: action.payload,
          setPasswordError: null,
        }
        break
      case SET_PASSWORD_FAILED:
       
        state = {
          ...state,
          user: null,
          loading: false,
          setPasswordError: action.payload,
        }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default pwdSet
  